// extracted by mini-css-extract-plugin
module.exports = {"item":"Accounts_item__b2EXO","fullName":"Accounts_fullName__1uh3Q"};